export const environment = {
  production: `false`,
  launchcontrolAdminDomain: `dev1-admin.dealerteamwork.com`,
  launchcontrolApiDomain: `dev1-api.dealerteamwork.com`,
  autoDomain: `auto-api.dev1-admin.dealerteamwork.com`,
  autoPort: `443`,
  mpopDomain: `adflex-api.dev1-admin.dealerteamwork.com`,
  envName: `undefined`
};
